import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["groupInfo"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSelector } from 'reselect';
import { deepClone, isEmpty } from '../../utils/helper';
import { DEFAULT_ACTIVE_MENU_TAB } from '../../constants/Constants';
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
/**
 * @description Selector Function for getting the specified state from reducer
 */
const getCards = state => state.LeftNavReducer.cards;
const getPinnedCards = state => state.LeftNavReducer.favPinnedCards;
const getGroups = state => state.LeftNavReducer.groups;
const getGroupTypes = state => state.LeftNavReducer.groupTypes;
const getGroupMap = createSelector([getGroups], groups => groups.reduce((result, group, index) => _objectSpread(_objectSpread({}, result), {}, {
  [group.groupKey]: _objectSpread(_objectSpread({}, group), {}, {
    cards: [],
    order: index
  })
}), {
  '': {
    cards: [],
    order: groups.length
  }
}));
const getGroupTypeMap = createSelector([getGroupTypes], groupTypes => groupTypes.reduce((result, groupType) => _objectSpread(_objectSpread({}, result), {}, {
  [groupType.key]: _objectSpread(_objectSpread({}, groupType), {}, {
    groupInfo: {}
  })
}), {}));
const getFormattedCards = createSelector([getCards, getPinnedCards, getGroupMap], (cards, favPinnedCards, groupMap) => cards.map(card => {
  const group = groupMap[card.groupKey];
  const pinnedCardKeys = favPinnedCards.map(pinnedCard => pinnedCard.appKey);
  return _objectSpread(_objectSpread({}, card), {}, {
    isPinned: pinnedCardKeys.includes(card.appKey)
  }, group ? {
    groupName: group.name,
    groupColor: group.colorCode
  } : {
    groupName: '',
    groupColor: ''
  });
}));
const cardListSelector = () => getFormattedCards;
const menuItemsListSelector = () => createSelector([getFormattedCards, getGroupMap, getGroupTypeMap], (cards, groupMap, groupTypeMap) => {
  if (isEmpty(groupMap) || isEmpty(groupTypeMap)) {
    const defaultGroupType = _objectSpread({}, groupTypeMap[DEFAULT_ACTIVE_MENU_TAB] || {
      'name': 'Apps',
      'order': 1,
      'key': 'apps',
      'icon': 'icon-view-latest-updates-24',
      'groups': []
    });
    return [_objectSpread(_objectSpread({}, defaultGroupType), {}, {
      groups: [...defaultGroupType.groups, {
        cards,
        order: 0
      }]
    })];
  }
  const newGroupTypeMap = deepClone(groupTypeMap);
  cards.forEach(card => {
    const {
      groupKey = ''
    } = card;
    const groupType = newGroupTypeMap[card.groupType] || newGroupTypeMap[DEFAULT_ACTIVE_MENU_TAB];
    if (!groupType.groupInfo[groupKey]) {
      groupType.groupInfo[groupKey] = [];
    }
    groupType.groupInfo[groupKey].push(card);
  });
  return Object.values(newGroupTypeMap).map(_ref => {
    let {
        groupInfo
      } = _ref,
      groupType = _objectWithoutProperties(_ref, _excluded);
    groupType.groups = Object.entries(groupInfo).map(_ref2 => {
      let [groupKey, groupCards] = _ref2;
      return _objectSpread(_objectSpread({}, deepClone(groupMap[groupKey])), {}, {
        cards: groupCards
      });
    }).sort((a, b) => a.order - b.order);
    return groupType;
  });
});
const favCardListSelector = () => createSelector([getFormattedCards, getPinnedCards], (cards, favPinnedCards) => {
  let filteredPins = [];
  favPinnedCards.forEach(val => {
    const obj = cards.filter(item => val.appKey === item.appKey);
    if (obj.length) {
      filteredPins = [...filteredPins, ...obj];
    }
  });
  return filteredPins;
});
const makeFavPinnedCards = () => createSelector(getPinnedCards, favPinnedCards => favPinnedCards);
const getActiveCard = () => createSelector(getCards, cards => {
  const currentLocation = window.location.pathname;
  const currentModulePrefix = "/".concat(currentLocation.split('/')[1]);
  let exactMatch = null;
  let moduleMatch = null;
  let modulePrefixMatch = null;
  cards.forEach(card => {
    if (card.path === currentLocation) {
      exactMatch = card;
    } else if (card.childPages && Array.isArray(card.childPages) && card.childPages.includes(currentLocation)) {
      moduleMatch = card;
    } else if (card.path.startsWith(currentModulePrefix)) {
      modulePrefixMatch = card;
    }
  });
  return exactMatch || moduleMatch || modulePrefixMatch;
});
export { cardListSelector, menuItemsListSelector, favCardListSelector, makeFavPinnedCards, getActiveCard };